<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import PayItemForm from "../../../components/payroll/payitem/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": PayItemForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuppayitem.newpayitem'),
      pageTitleValue: "",
      formData: {
        payitemcode: null,
        payitemdesc: null,
        payitemtypeid: null,
        cofringe: false,
        arritem: false,
        basdep: false,
        regitem: false,
        startdate: null,
        enddate: null,
        prorateid: null,
        roundingid: null,
        roundto: null,
       // decimalval: null,
        remark: null,
        affecttypeid: null,
        taxexemptionid: null,
  
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      // change boolean to int
      if (this.formData.cofringe == true) {
        this.formData.cofringe = 1;
      } else {
        this.formData.cofringe = 0;
      }

      if (this.formData.arritem == true) {
        this.formData.arritem = 1;
      } else {
        this.formData.arritem = 0;
      }

      if (this.formData.basdep == true) {
        this.formData.basdep = 1;
      } else {
        this.formData.basdep = 0;
      }

      if (this.formData.regitem == true) {
        this.formData.regitem = 1;
      } else {
        this.formData.regitem = 0;
      }

      this.$store.dispatch('post', {url: "/payitem/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "payitemlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "payitemlist" });
    },
  },
};
</script>